<template>
  <div id="productH5DetailPage">
		<plugin />
		<productAddCart :goods='goodsMsg'  @addCartShowFN="addCartShowFN"  v-if='addCartShow' />
		<div class='editorBox' v-if = "articleShow">
			<div id="editor" v-html="contentNode" ></div>
			<img src="../assets/icon-delete.png"  @click="closeEditor" class='editorCloseImg' style='cursor:pointer;'></img>
		</div>
		
		<div v-if='previewImgShow' class='previewImg'>
			<img :src="goodsDetail.nutrition_img" class='previewImage'>
			<img src="../assets/icon-delete.png"  @click="closeEditor" class='editorCloseImg' style='cursor:pointer;'></img>
		</div>
		
		<!-- 选择文件 -->
		<!-- <input type="file" accept="image/*"> -->
		
		<!-- 调用摄像头 -->
		<!-- <input type="file" capture="camera"/>  -->
		<div class="footer-bar" >
		        <div class="app-btn" @click='toCart'>查看橘袋</div >
		        <div class="app-btn" v-if='goodsDetail.isStockHave' @click='openAddCart'>加入橘袋</div >
		        <div class="app-btn" v-if='!goodsDetail.isStockHave' style='background:#C0BFC1'>已售罄</div >
		</div>


					<div class="productDetailImg" >
		                       <img :src="goodsDetail.index_img" />
					</div>     
		            <div class="productDetailContent">
		                <div class="productDetailContentname">{{goodsDetail.goods_name}}</div>
		                <div class="productDetailContentuseday">推荐服用：每天{{goodsDetail.day_use}}颗</div>
		                <div class="productDetailContentprice">
		                    <span>{{goodsDetail.price}}元 </span>/月
		                </div>
		                <div class="productDetailContenttags">
		                    <div v-for='item in goodsDetail.cat'>
								 <img :src="item.url" />
		                        <div>{{item.title}}</div>
		                    </div>
		                </div>
		            </div>
					<div v-for="itemurl in parseImg" class='productDetailTitleImg'>
						<img :src="itemurl" alt="">
					</div>
		     

				<div class="attributes">
					<div class="page-title">产品规格</div>
					<div class="content">
						<div class="name" style='font-weight:700'>{{goodsDetail.goods_name}}</div>
						<div class="tags">
							<div v-for='item in goodsDetail.cat' >
							<img :src="item.url" />
						</div>
					</div>
					<div class="speciality">
						<div v-for='item in goodsDetail.goods_label'>
							<img :src="item.img_url"/>{{item.title}} 
						</div>
					</div>
					<div class="tag-btn" @click='openPreview' >
						<span>100%透明营养成分表</span>
						<img src="../assets/icon-next2.png" />
					</div>

					<div class="title">每日用量</div>
					<div class="use-quantity area">
						<img src="../assets/icon-yao.png"/>
						<div>{{goodsDetail.day_use}}颗</div>
					</div>

					<div class="title" v-if='goodsDetail.goods_unit&goodsDetail.goods_unit.length>0'>产品剂量</div>
					<div class="dose area" v-if='goodsDetail.goods_unit.length>0&&goodsDetail.goods_unit.length<2'>
						<div class="item1">
							<div>{{goodsDetail.goods_unit[0].unit_size}}</div>
							<div>{{goodsDetail.goods_unit[0].unit_name}}</div>
						</div>
					</div>
					<div class="dose area" v-if='goodsDetail.goods_unit.length>1'>
						<div class="item" v-for='item in goodsDetail.goods_unit' >
							<div>{{item.unit_size}}</div>
							<div>{{item.unit_name}}</div>
						</div>
					</div>
					<div class="title" v-if='goodsDetail.other_component'>其他成分</div>
					<div class="area"  v-if='goodsDetail.other_component'>{{goodsDetail.other_component}}</div>

					<div class="title" v-if='goodsDetail.exclusive'>产品不包含</div>
					<div class="area"  v-if='goodsDetail.exclusive'>{{goodsDetail.exclusive}}</div>
					</div>
			    </div>
			    <div class="articles" v-if='reportList&&reportList.length>0'>
			        <div class="page-title">相关研究</div>
			        <div class="article" v-for='item in reportList' @click='getArticle(item.id)'>
			            <div class="name">{{item.title}}</div>
			            <div class="description">{{item.intro}}</div>
			            <div class="more">详情 <img src="../assets/icon-next3.png"/></div>
			        </div>
			    </div>
			    <div class="footer-bar--pad"></div>
			</div>
		
		
		
  </div>
</template>

<script>
import plugin from '@/components/plugin.vue'
import productAddCart from '@/components/productAddCart.vue'
export default {
  name: 'productH5Detail',
  components: {
	productAddCart,
	plugin
  },
  data:()=>{
    return{
		addCartShow:false,
		goodsMsg:"",
		goodsDetail:{},
		parseImg:[],
		reportList:[],
		contentNode:"",
		articleShow : false,
		previewImgShow:false,
		moreImg:require('@/assets/icon-next3.png')
    }
  },
	
	created:function(){
		
		this.goodsid = this.$route.query.id
		this.getGoodsDetail()
	},
 
  
  methods:{
	  
	// 做问卷
	toQuestions(){
		this.$router.push({name: 'beforeQuestion'});
	},
	editorStart(e){
		console.log(e)
	},
	editorEnd(e){
		console.log(e)
	},
	// 获取商品详情
	 getGoodsDetail(){
	   let that = this
	  if(!this.$route.query.id){
	   this.$router.replace({
	  			name: 'productH5'
	  		})
	  }
		this.axios({
			method: 'post',
			url:"goods/goodsDetail",
			data:{
			goods_id: this.goodsid
	   	   }
		}).then(res=>{
			res.data.goods_detail.isStockHave = true
			if (Number(res.data.goods_detail.day_use) * 30 > res.data.goods_detail.goods_stock) {
			res.data.goods_detail.isStockHave = false
			}
			res.data.goods_detail.price = Number(res.data.goods_detail.day_use * 30 * res.data.goods_detail.shop_price)
			res.data.goods_detail.images = res.data.images
			that.changeHtml(res.data.goods_detail.goods_desc)
			that.goodsDetail=res.data.goods_detail
			that.reportList = res.data.report_list
	    })
	    
	},
	// 转换富文本
	changeHtml(htmlString){
		let _string = htmlString
		let patt1 = /<img\s+[^><]*?src=([\'"])([^><]+?)\1[^><]*?>/g
		let arr = _string.match(patt1);
		let _parseImg = []
		if (arr){
		  arr.forEach((item) => {
			item = item.split("src=")
			item = item[1].split(" ")
			item = "https://admin.xiaojudai.cn" + item[0].replace("\"", "").replace("\"", "");
			_parseImg.push(item)
		  })
		}
		console.log(_parseImg)
		this.parseImg = _parseImg        
	},
	// 相关文章
	getArticle:function(_id){
	    let that = this
		this.axios({
			method: 'post',
			url:"goods/reportDetail",
			data:{
				id: _id
		   }
		}).then(res=>{

	        this.contentNode=res.data.report.content
			this.articleShow = true
	    })
	    
	 },
	 // 关闭文章
	 closeEditor(){
		 this.articleShow = false
		 this.previewImgShow = false
	 },
	 openPreview(){
		 this.previewImgShow = true
	 },
	// 打开加入橘袋组件
	openAddCart(){

		this.goodsMsg = this.goodsDetail
		this.addCartShow = true
	},
	// 关闭加入橘袋组件
	addCartShowFN(){
		this.addCartShow = false
	},
	toCart(){
		this.$router.push({
			path:"cart"
		})
	},
  },

}
</script>
<style>
#productH5DetailPage{
  background:rgba(255,255,255,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
  overflow-y:auto;
}
#productH5DetailPage::-webkit-scrollbar {display:none}

.editorBox,.previewImg{
	  padding: 0.63rem;
	  width: 7.5rem;
	  text-align: center;
	  font-size: 0.27rem;
	  color: #141414;
	  letter-spacing: 0.02rem;
	  height: 100vh;
	  box-sizing: border-box;
	  position: fixed;
	  left:50%;
	  transform: translate(-50%,0); 
	  background-color: #fff;
	  z-index: 20;
}
.previewImg .previewImage{
	width: 100%;
	padding-top:2rem;
}
#editor{
	width: 100%;
	height: 100%;
	overflow-y:auto;
}
#editor::-webkit-scrollbar {display:none}
.editorCloseImg{

	  position: absolute;
	  right: 0.4rem;
	  top:0.1rem;
	  width: 0.24rem;
	  height: 0.24rem;
	  padding: 0.26rem;
	  box-sizing: content-box;
	  cursor:pointer;
	
}


.productH5PageTop-title{
	font-weight: bold;
	font-size: 0.56rem;
	line-height: 0.83rem;

}
.productH5PageTop-description{
	color: #505050;
	padding: 0.5rem 0;
	line-height: 0.44rem;

}
.itemstype{
    height: 3.6rem;
    display: flex;
    flex-wrap: wrap;
}
.itemtype{
    width: 1.5rem;
    height: 1.5rem;
    box-sizing: border-box;
    border:0.03rem solid rgba(224, 227, 222, 1);
    border-radius: 0.11rem;
    margin-left:0.3rem;
    margin-bottom:0.3rem;
	cursor:pointer;
}
.itemtypeicon{
  width:0.64rem;
  height:0.64rem;
  margin:0.3rem auto 0;
}
.itemtypename{
  font-size: 0.22rem;
  color: rgba(51, 51, 51, 1);
  width: 1.5rem;
  height:0.6rem;
  line-height:0.6rem;
  text-align: center;
}
.itemtype img{
    width:0.64rem;
    height:0.64rem;
}
.itemtypeactive{
  background-color: rgba(224, 227, 222, 1);
}
.productDetailImg{
	width: 7.5rem;
}
.productDetailImg img{
	width: 100%;
}
.productDetailContent{
	text-align: left;
	padding: 0.6rem;
	position: relative;
	box-sizing: content-box;
}
.productDetailContentname{
		font-weight: bold;
	    font-size: 0.42rem;
	    line-height: 0.59rem;
	    height: 0.59rem;
	    margin-bottom: 0.06rem;
}
.productDetailContentuseday{
		height: 0.37rem;
	  color: rgba(114, 113, 113, 0.8);
	  font-size: 0.26rem;
	  font-weight: 500;
	  margin-bottom: 0.6rem;
}
.productDetailContentprice{
	 position: absolute;
	  right: 0.24rem;
	  top:0.66rem;
	  color: rgba(20, 20, 20, 1);
	  font-size: 0.24rem;
	  font-weight: 600;
}
.productDetailContentprice span{
  color: rgba(194, 94, 77, 1);
  font-size: 0.36rem;
  font-weight: 700;
}
.productDetailContenttags{
	display: flex;
	overflow: hidden;
}

.productDetailContenttags>div {
    margin-right: 0.2rem;
    padding-right: 0.3rem;
    color: #141414;
    font-size: 0.24rem;
}
.productDetailContenttags>div div {
    margin-top: 0.14rem;
}
.productDetailContenttags img {
    width: 0.5rem;
    height: 0.5rem;
    margin: 0 auto 0.1rem auto;
}
.productDetailTitleImg{
	width: 7.5rem;
}
.productDetailTitleImg img{
	width: 100%;
}


.page-title {
    font-size: 0.36rem;
    font-weight: bold;
    position: relative;
    text-align: center;
    margin: 1.04rem 0 0.88rem 0;
    line-height: 0.5rem;
    overflow: visible;
}
.page-title:after {
    position: absolute;
    content: "";
    left: 36%;
    right: 36%;
    bottom: -0.25rem;
    height: 0.06rem;
    background: #C25E4D;
    border-radius: 0.03rem;
}
.attributes{
	text-align: left;
}
 .content {
    background: #fff;
    margin: 0 0.4rem 0.4rem 0.4rem;
    padding: 0.6rem 0.4rem;
    border-radius: 5px;
    box-shadow: 0px 0px 1rem rgba(198, 206, 219, 0.23);
    color: rgba(20, 20, 20, 1);
}
.attributes .name {
    font-size: 0.36rem;
    font-weight:600;
    padding-bottom:0.42rem;
    position: relative;
    color: rgba(20, 20, 20, 1);
}
.attributes .tags {
    display: flex;
}
.attributes .tags>div {
    margin-right: 0.2rem;
}
.attributes .tags img {
    width: 0.4rem;
    height: 0.4rem;
}
.attributes .speciality {
    padding: 0.5rem 0;
}
.attributes .speciality div {
    display: flex;
    align-items: center;
    margin-bottom: 16rpx;
}
.attributes .speciality div img {
    width: 0.64rem;
    height: 0.64rem;
    margin-right: 0.2rem;
}
.attributes .tag-btn {
    margin: 0.3rem 0;
    border-radius: 45px;
    border: 1px solid #DADDD8;
    padding: 0.24rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #727171;
}
.attributes .tag-btn img {
    width: 0.18rem;
    height: 0.31rem;
    margin-left: 0.2rem;
}

.attributes .content>.title {
    margin: 0.6rem 0 0.3rem 0;
    font-size: 0.32rem;
}
.attributes .area {
    border-radius: 6px;
    border: 4px solid rgba(242, 244, 248, 1);
    padding: 0.3rem;
}
.attributes .use-quantity {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0.8rem 0;
}
.attributes .use-quantity img {
    width: 0.8rem;
    margin-bottom: 0.1rem;
}

.attributes .dose {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0.2rem;
}
.attributes .dose .item {
    width: 40%;
    text-align: center;
    padding: 5%;
    position: relative;
}
.attributes .dose .item1 {
    width: 40%;
    text-align: center;
    padding: 5%;
    margin: 0 auto;
    position: relative;
}
.attributes .dose .item:after {
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: #F2F4F8;
}
.attributes .dose .item:before {
    position: absolute;
    content: "";
    top: 0.2rem;
    right: 0;
    bottom: 0.2rem;
    width: 1px;
    background: #F2F4F8;
}
.attributes .dose .item:nth-child(2n)::before {
    width: 0;
}
.attributes .dose .item1 div:first-child {
    font-weight: bold;
    font-size: 0.3rem;
}
.attributes .dose .item1 div:last-child {
    color: #9B9B9B;
    font-size: 0.24rem;
    margin-top: 0.1rem;
}
.attributes .dose .item div:first-child {
    font-weight: bold;
    font-size: 0.3rem;
}
.attributes .dose .item div:last-child {
    color: #9B9B9B;
    font-size: 0.24rem;
    margin-top: 0.1rem;
}

/* 相关研究 */
.articles .article {
    background: #fff;
    margin: 0 0.5rem 0.5rem 0.5rem;
    padding: 0.4rem 0.35rem;
    border-radius: 5px;
    box-shadow: 0px 0px 1rem rgba(198, 206, 219, 0.23);
	text-align: left;
}
.articles .article .name {
    font-size: 0.38rem;
    font-weight: bold;
}
.articles .article .description {
    color: #666;
    line-height: 0.4rem;
    padding: 0.3rem 0;
}
.articles .article .more {
    color: #C25E4D;
    font-size: 0.24rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.articles .article .more img {
    width: 0.15rem;
    margin-left: 0.2rem;
}

.footer-bar--pad {
    height: 1.8rem;
}
.footer-bar {
    position: fixed;
	width: 7.5rem;
	bottom:0;
    height: 1.68rem;
	z-index: 2;
    left:50%;
    transform: translate(-50%,0); 
    background: #fff;
    box-shadow: 0px -6px 20px 0px rgba(0,0,0,0.08);
	justify-content: center;
}


.footer-bar .app-btn {
    width: 40%;
    height: 0.9rem;
    margin-right: 0.3rem;
    margin-top: 0.39rem;
	line-height: 0.9rem;
}
.footer-bar .app-btn:last-child {
    margin-right: 0;
}
.footer-bar .app-btn:first-child {
    background: #fff;
        color: #C25E4D;
        font-weight: 500;
    box-shadow: 0px 1px 5px 2px RGBA(244, 227, 224, 0.8);
}
#productH5DetailPage .creatcartBoxtop{
  bottom:0rem;
}
#productH5DetailPage .delCartMask{
bottom:0rem;
}
#productH5DetailPage .creatCartMask{
	bottom:0rem;
}
</style>